import React, { useState } from 'react';
import { PREPOPULATE_ADDRESS, REMOVE_PREPOPULATED_ADDRESS } from 'helpers/types';
import { Formik, ErrorMessage } from 'formik';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import { validatePostcode } from 'helpers/yupmatchers';
import usePostcode from 'hooks/usePostcode';
import styles from './style.module.css';
import { useHistory } from 'react-router-dom';
import useQuery from 'hooks/useQuery';
import { Spinner } from 'components';

const AddNewAddressByPostcodeFormSchema = Yup.object().shape({
  postcode: validatePostcode,
});

const AddNewAddressByPostcodeForm = () => {
  let query = useQuery();
  const dispatch = useDispatch();
  const history = useHistory();
  const [submitted, setSubmitted] = useState(false);
  const values = { postcode: '' };
  const [postcodes, getPostcode] = usePostcode();
  const accountView = query.get('view') === 'account' ? true : false;

  const submitForm = async (payload) => {
    setSubmitted(true);
    getPostcode(payload.postcode);
  };

  const prepopulateAddress = (payload) => {
    dispatch({
      type: PREPOPULATE_ADDRESS,
      payload: {
        nickname: '',
        address_line1: payload.address_line1,
        address_line2: '',
        city_town: payload.address_line2,
        county: payload.address_line3,
        postcode: payload.postcode,
      },
    });
    history.push(
      accountView ? '/pharmacy/dashboard/account/address/new?view=account' : '/pharmacy/dashboard/account/address/new'
    );
  };

  const enterAddressManually = (e) => {
    e.preventDefault();
    dispatch({ type: REMOVE_PREPOPULATED_ADDRESS });
    history.push(
      accountView ? '/pharmacy/dashboard/account/address/new?view=account' : '/pharmacy/dashboard/account/address/new'
    );
  };

  return (
    <>
      <Formik
        initialValues={values}
        validationSchema={AddNewAddressByPostcodeFormSchema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={(values) => submitForm(values)}>
        {(props) => (
          <form className={styles.form} onSubmit={props.handleSubmit}>
            <div>
              <h2 className={styles.formHeader}>Search delivery address</h2>
              <label className={styles.inputLabel} htmlFor="postcode">
                Enter a postcode
              </label>
              <ErrorMessage
                name="postcode"
                render={(msg) => <div className={`coop-c-form-error__text ${styles.errorText}`}>{msg}</div>}
              />
              <input
                maxLength="255"
                id="postcode"
                type="text"
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                value={props.values.postcode}
                className={`coop-form__input ${
                  props.errors.postcode && props.touched.postcode && 'coop-form__invalid'
                }`}
                name="postcode"
              />
            </div>
            <button type="submit" className={`coop-btn coop-btn--primary coop-c-hero__cta ${styles.submit}`}>
              Search
            </button>
          </form>
        )}
      </Formik>
      <button type="button" className={styles.manual} onClick={(e) => enterAddressManually(e)}>
        Enter Address Manually
      </button>
      {postcodes.length === 0 && submitted && <Spinner />}
      {postcodes && submitted && (
        <>
          <hr className={styles.addressHr} />
          <p className={styles.addressResultsText}>Search results for postcode</p>
          <div className={styles.addressListContainer}>
            {postcodes.length <= 0 && submitted && <p className={styles.addressResultsFailText}>No results</p>}
            <ul className={styles.addressList}>
              {postcodes.map((postcode) => (
                <li key={postcode.address_line1} onClick={() => prepopulateAddress(postcode)}>
                  {postcode.address_line1}, {postcode.address_line2}
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </>
  );
};

export default AddNewAddressByPostcodeForm;
